import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { HoverIconButton } from 'components/button/HoverIconButton';
import { IssueUserInfo } from 'pages/Desk/issues/types';
import { UserDetails } from 'pages/Desk/issues/UserDetails';
import { useRef } from 'react';
import { HoverTooltip } from 'shared/hover_tooltip/HoverTooltip';
import { UserAvatar } from 'shared/user_avatar/UserAvatar';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';
import { stopEvent } from 'utils/event';

export const UserTagWrapper = styled.div<{ $deletable: boolean }>`
    display: inline-flex;
    width: max-content;
    overflow: hidden;
    font-size: 1.2rem;
    align-items: center;
    justify-content: space-between;
    border-radius: 16px;
    box-sizing: border-box;
    border: 1px solid ${tokens.border.default};
    color: ${tokens.text.primary};
    background-color: ${tokens.action.selected};
    padding: ${({ $deletable }) =>
        $deletable ? '0rem 0.1rem' : '0rem 1rem 0rem 0.1rem'};
`;

export const UserTagUserWrapper = styled.div`
    display: flex;
    gap: 0.5rem;
    align-items: center;
    cursor: default;
`;

export const UserTagUserName = styled.div`
    max-width: 19rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const UserTagFontSize = '1rem';
export const UserTagAvatarSize = '2.6rem';

export type UserTagProps = Readonly<{
    user: IssueUserInfo;
    onRemove?: () => void;
}>;

export function UserTag({ user, onRemove }: UserTagProps) {
    const anchorRef = useRef<HTMLDivElement>(null);
    const { firstName, lastName } = user;

    return (
        <UserTagWrapper data-tag-wrapper $deletable={!!onRemove}>
            <UserTagUserWrapper>
                <UserAvatar
                    firstName={firstName}
                    lastName={lastName}
                    fontSize={UserTagFontSize}
                    size={UserTagAvatarSize}
                />
                <UserTagUserName ref={anchorRef}>
                    {firstName} {lastName}
                </UserTagUserName>
                <HoverTooltip anchorRef={anchorRef} noPadding>
                    <UserDetails user={user} />
                </HoverTooltip>
            </UserTagUserWrapper>
            {onRemove && (
                <HoverIconButton
                    ariaLabel={`Remove ${firstName} ${lastName}`}
                    icon={faTimes}
                    hoverIcon={faTimes}
                    color={tokens.icon.actionActive}
                    hoverColor={tokens.icon.actionHover}
                    onClick={(e) => {
                        stopEvent(e);
                        onRemove();
                    }}
                />
            )}
        </UserTagWrapper>
    );
}
